module.exports = __webpack_public_path__ + "img/smartsemiochat.a569a09d.png";